function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1580.041,1180.155h-1v-2.083a1.93,1.93,0,0,0-2-1.917h-10a1.931,1.931,0,0,0-2,1.917v2.083h-1l-2,5.917v8a2.073,2.073,0,0,0,2,2.083h16a2.073,2.073,0,0,0,2-2.083v-8Zm-13-1.083a.932.932,0,0,1,1-.917h8a.932.932,0,0,1,1,.917v7.083h-1a1.931,1.931,0,0,0-2,1.917v1a1.074,1.074,0,0,1-1,1.083h-2a1.075,1.075,0,0,1-1-1.083v-1a1.93,1.93,0,0,0-2-1.917h-1Zm-2,4v3.083h-1Zm15,10a1.074,1.074,0,0,1-1,1.083h-14a1.075,1.075,0,0,1-1-1.083v-4.917h3a.932.932,0,0,1,1,.917v1a2.073,2.073,0,0,0,2,2.083h4a2.073,2.073,0,0,0,2-2.083v-1a.932.932,0,0,1,1-.917h3Zm-1-6.917v-3.083l1,3.083Zm-9.828-2.586a1,1,0,0,1,1.414-1.414l.707.707,2.122-2.121a1,1,0,0,1,1.414,1.414l-3.536,3.535Z",
  transform: "translate(-1562.041 -1176.155)",
  fill: "#b40000"
});

var SvgInboxDoneRound = function SvgInboxDoneRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInboxDoneRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inbox_done_round.1739eecc.svg";
export { ForwardRef as ReactComponent };